"use strict";

(function (global) {

  /**
  * Шаблоны ячеек
  */
  var TEMPLATES = {
    CELL: 'components/grid/cell.compile.html',
    CELL_WITH_MENU: 'components/grid/contextMenuCell.compile.html'
  };

  /**
  * Дата-аттрибуты контейнеров
  * @inner
  */
  var DATA_ATTR = {
    COLUMNS: 'columns',
    SECTION_NUMBER: 'detailSectionNumber',
    BUILDER_EVENTS_ENABLED: 'builderEventsEnabled',
    COLUMN_AUTO_WIDTH: 'columnAutoWidth'
  };

  /**
  * Поиск и создание таблиц детальных разделов.
  * 
  * @class WebAccess.components.wrappers.details.DetailsInitializer
  * @extends BaseObject
  * @property {Array<WebAccess.components.dataViews.Grid>} gridInstances экземпляры таблиц  
  * @param {String} detailsSelector селектор контейнеров детальных разделов
  * @param {WebAccess.components.dataViews.BaseDataProvider} DataProviderClass 
  * @since 5.2.0.1600
  */
  var DetailsInitiializer = BaseObject.extend({
    gridInstances: null,

    _detailsSelector: null,
    _dv: null,
    _jDetails: null,
    _cellMarkUp: null,
    _templates: null,
    _contextMenuMarKUp: null,
    _form: null,

    init: function (detailsSelector, DataProviderClass, dataProviderOptions, ContextMenuClass, current) {
      var me = this;
      me._super(detailsSelector);
      me._current = current;

      me.DataProviderClass = DataProviderClass;
      me.dataProviderOptions = dataProviderOptions;

      me.ContextMenuClass = ContextMenuClass;
      var templates = {};
      var load = WA.templates.load;

      $.when(
        load(TEMPLATES.CELL),
        load(TEMPLATES.CELL_WITH_MENU)
      ).done(function (cell, cellWithMenu) {
        templates.cellMarkUp = cell;
        templates.contextMenuMarkUp = cellWithMenu;

        me.gridInstances = {};
        me._templates = templates;
        me._dv = WA.CMP.dataViews;
        me._detailsSelector = detailsSelector;

        me._jDetails = $(me._detailsSelector);

        me._setTemplates();
        me._initializeGridInstances();
        setTimeout(function () {
          me.fire(DetailsInitiializer.EVENT.COMPLETE, me);
        }, 10)
      });
    },
    //-----------------------------------------------------------------------//

    /**
    * Поиск и создание экземпляров таблиц
    * @private
    * @method WebAccess.components.wrappers.details.DetailsInitializer#_initializeGridInstances
    * @return {WebAccess.components.wrappers.details.DetailsInitializer}
    */
    _initializeGridInstances: function () {
      var me = this;
      var isSideBarBindEventBeforeTab = false;

      me._jDetails.each(function () {
        var jTable = $(this);

        var dfmName = jTable.attr('id');
        var columns = me._getExtraColumns();
        var sectionNumber = +jTable.data(DATA_ATTR.SECTION_NUMBER);
        var columnAutoWidth = jTable.data(DATA_ATTR.COLUMN_AUTO_WIDTH);

        var isBuilderEventsEnabled = jTable.data(DATA_ATTR.BUILDER_EVENTS_ENABLED);
        var dataProvider = new me.DataProviderClass($.extend({}, me.dataProviderOptions, {
          DetailSectionNumber: sectionNumber,
          DFMName: dfmName
        }), me._current);

        columns = columns.concat(jTable.data(DATA_ATTR.COLUMNS));
        var sortedColumns = {};
        var num = 0;
        Object.keys(columns).sort(function (a, b) {
          return columns[a].Index - columns[b].Index;
        }).forEach(function (index) {
          sortedColumns[num++] = columns[index];
        });

        var getCellTemplate = function (rowNumber, cellNumber, value, columnDef, dataContext) {
          var refCode = '';
          if (columnDef.type == REQUISITE_TYPE.REFERENCE && columnDef.requisite) {
            refCode = columnDef.requisite.referenceName;
          }
          var recordId = dataContext.id;
          switch (columnDef.id) {
            case '_contextMenu':
              return me._contextMenuMarkUp.render({ index: dfmName, recordId: recordId });
            default:
              var valueId = dataContext[columnDef.id];
              return me._cellMarkUp.render({
                hasValue: (!!valueId && valueId !== '*' && !!refCode),
                id: valueId,
                value: value,
                refCode: refCode,
                openCardButtonTitle: L('OPEN_CARD')
              });
          }
        };

        var grid;

        var getRowAdditionalInfo = function (rowNumber, data) {
          var row = data.getItem(rowNumber);
          if (row && row.__nonDataRow !== true) {
            return {
              cssClasses: 'List',
              attributes: {
                'id': row.id,
                'kind': 'REF',
                'compcode': WA.CR.getReferenceCode(),
                'data-recid': row.id,
                'contextmenu': function (event) {
                  grid.openContextMenu(this, event);
                },
                'click': function (event) {
                  if (event.target && $(event.target).is('.popup_menu')) {
                    grid.openContextMenu(this, event);
                  }
                }
              }
            };
          }
        };

        //Инициализируем грид
        grid = new me._dv.Grid(jTable, dataProvider, sortedColumns, {
          plugins: me._getAvailablePlugins(dfmName),
          getRowAdditionalInfo: getRowAdditionalInfo,
          cellTemplate: getCellTemplate,
          isBuilderEventsSupported: isBuilderEventsEnabled,
          DFMName: dfmName,
          sectionNumber: sectionNumber,
          current: me._current
        });

        grid.autoAdjustColumnWidth(columnAutoWidth);

        //Добавляем контекстное меню при клике в пустое место        
        if (me.ContextMenuClass) {
          jTable.find('.slick-viewport').on('contextmenu', function (ev) {
            grid.openContextMenu(this, ev);
          });
        }

        me.gridInstances[dfmName] = grid;

        me._current.Init.done(function () {
          if (!isSideBarBindEventBeforeTab) {
            isSideBarBindEventBeforeTab = true;
            var sideBar = me._current.sideBar;
            // При переключении вкладки отправляем запрос на сервер для установки 
            // значений реквизитов, но не сохраняем в базу. После проверяем если есть 
            // такой же детальный раздел на переключаемой вкладке, то перезагружаем 
            // (подтягиваем новые данные с сервера) этот детальный раздел. 
            sideBar.bind(sideBar['class'].EVENT.BEFORE_TAB_SWITCH, function () {
              var currentTabName = sideBar.tabs.current.name;
              _(_(me._current.form.controls.tables).filter(function (table) {
                return table.isChanged() && table.parentTabName === currentTabName;
              })).each(function (table) {
                var details = me._current.details[table.detailNum];
                me._current.form.save(function () {
                  _(details.getTables().toArray()).each(function (table) {
                    table.reloadData();
                    table._isChanged = false;
                  })
                }, false);
              })
            });
          }
        });
      });

      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Ожидание загрузки данных.
    * @method WebAccess.components.wrappers.details.DetailsInitializer#waitForData
    * @return {Deferred} Специальный Deferred-объект.
    */
    waitForData: function () {
      var me = this;
      var stateVariable = $.Deferred();

      //Инициализацию гридов делать не всегда, а только где они есть
      if ($.isEmptyObject(me.gridInstances)) {
        stateVariable.resolve();
        return stateVariable;
      }

      var states = [];
      for (var detailName in me.gridInstances) {
        var state = $.Deferred();
        states.push(state);
        (function (state) { //замкнуто, чтобы state нужный был внутри
          me.gridInstances[detailName].bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, function (data) {
            state.resolve();
          });
        })(state);
      }

      $.when.apply($, states).done(function () {
        stateVariable.resolve();
      });
      return stateVariable;
    },

    _getExtraColumns: function () {
      var columns = [];
      if (WA.ENV.isTouch()) {
        columns.push({
          Caption: '&nbsp;',
          Field: '_contextMenu',
          Name: '_contextMenu',
          IsVisible: true,
          type: REQUISITE_TYPE.EMPTY,
          Width: 30,
          Index: 0
        });
      }

      return columns;
    },
    //-----------------------------------------------------------------------//


    /**
    * Заполнение обьектов шаблонов
    * @method WebAccess.components.wrappers.details.DetailsInitializer#_setTemplates
    * @return {Deferred} Специальный Deferred-объект.
    */
    _setTemplates: function () {
      var me = this;
      me._cellMarkUp = me._templates.cellMarkUp;
      me._contextMenuMarkUp = me._templates.contextMenuMarkUp;
    },
    //-----------------------------------------------------------------------//

    /**
    * Заполнение обьектов шаблонов
    * @method WebAccess.components.wrappers.details.DetailsInitializer#_getAvailablePlugins
    * @return {Deferred} Специальный Deferred-объект.
    */
    _getAvailablePlugins: function (dfmName) {
      var me = this;
      var plugins = [
        new me._dv.gridPlugins.EditPlugin(),
        new me._dv.gridPlugins.SortingPlugin(),
        new me._dv.gridPlugins.ColumnResizePlugin({
          // Отключаем в плагине реакцию на ресайз окна, т.к. на планшетах
          // ресайз вызывает появление клавиатуры в редактируемых ячейках, 
          // а после этого события грид перестраивается и клавиатура 
          // убирается (замечание №103899). Да и незачем детальным разделам 
          // изменять свой размер или перерисовываться.
          "disableOnResizeBinding": true
        })
      ];
      if (me.ContextMenuClass) {
        var menu = new me.ContextMenuClass(dfmName);
        plugins.push(new me._dv.gridPlugins.ContextMenuPlugin(menu, me._current))
      };
      return plugins;
    }
    //-----------------------------------------------------------------------//
  }, {
      EVENT: {
        COMPLETE: 'complete'
      }
      //-----------------------------------------------------------------------//
    });

  global.DetailsInitiializer = DetailsInitiializer;
})(window.WebAccess.components.wrappers.details);